import styled from 'styled-components';
import { hoverCapable } from '../../../../styles/hover';

/** Área táctil de 44 x 44 px aunque el icono mida ~20 px. */
export const FlagButton = styled.button<{ $flagged: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  background: transparent;
  cursor: pointer;
  color: ${({ theme, $flagged }) =>
    $flagged ? theme.colors.primary : theme.colors.text};

  ${hoverCapable} {
    &:hover {
      background-color: ${({ theme }) => theme.colors.backgroundLila};
    }
  }

  &:focus-visible {
    outline: 0.2rem solid ${({ theme }) => theme.colors.primary};
    outline-offset: -0.2rem;
  }
`;
